import { latestDataPointGroupUpdateDate, latestDataPointGroupUpdateDateTime } from '../../DataPointGroup';
import { decayedLimit, isDecayed } from '../../util';
import { AmountSumTableItem, AmountSumTableItemProps } from './Table';
import { CashAccount } from '../../generated/graphql';

export interface CashAccountSumTableItemProps
  extends Pick<
    AmountSumTableItemProps,
    'amount' | 'className' | 'subtitle' | 'withChevron' | 'contentPrefix' | 'motionProps'
  > {
  itemTitle?: string;
  cashAccount: CashAccount;
  onItemClicked?: (a: { cashAccount: CashAccount }) => void;
}

export const CashAccountSumTableItem = ({ cashAccount, onItemClicked, ...props }: CashAccountSumTableItemProps) => {
  return (
    <AmountSumTableItem
      linkStatus={cashAccount.linkStatus}
      motionProps={props.motionProps}
      key={cashAccount.id}
      contentPrefix={props.contentPrefix}
      title={props.itemTitle ?? cashAccount.name}
      dataTestID={cashAccount.name}
      withChevron={props.withChevron ?? !!onItemClicked}
      amount={cashAccount.ownedValue}
      className={props.className}
      subtitle={props.subtitle}
      onClick={() => onItemClicked?.({ cashAccount })}
      lastUpdated={latestDataPointGroupUpdateDateTime(cashAccount.value)}
      onKeyDown={(e) => e.key === 'Enter' && onItemClicked?.({ cashAccount })}
      decayed={isDecayed(latestDataPointGroupUpdateDate(cashAccount.value), decayedLimit.CashAccount)}
    />
  );
};
